module.exports = __webpack_public_path__ + "static/media/newlywed_life_a.721e60fc.svg";